// extracted by mini-css-extract-plugin
module.exports = {"available":"styles_available__2xx0b"};